import MarketingModule from "./marketingModule";
import MarketingSagas from "./redux/marketingSagas";
import MarketingReducer from "./redux/marketingReducer";

export default {
  Component: MarketingModule,
  moduleName: "marketing",
  saga: MarketingSagas(),
  reducer: MarketingReducer
};
